<form
    pcgSubmitUrl="api/Administration/Users/SaveUser"
    (messageSuccess)="onMessageSuccess($event)"
    [formGroup]="formGroup"
>
    <input type="hidden" formControlName="userId" />

    <div class="row mt-2 mb-2 ml-2">
        <div id="activation">
            @if (isLockedOut) {
                <div id="divUnlockUser" (click)="unlockUser()">
                    <fa-icon
                        [icon]="faIconName.faUnlock"
                        class="unlockIcon fa-2x"
                        ngbTooltip="This user is locked out. Click here to unlock the user and send them an email with login instructions."
                    ></fa-icon>
                    <span class="unlockLable">Locked Out (Click to unlock)</span>
                </div>
            }

            <pcg-control-group class="activate">
                <p [class.text-danger]="!model.isActive" [class.d-none]="model.isActive">This user is deactivated.</p>
                @if ((canManageUsers ? true : null) && id !== 0) {
                    <a
                        [class.btn-danger]="model.isActive"
                        [class.btn-save]="!model.isActive"
                        class="btn btn-sm"
                        (click)="activateDeactivate(); model.isActive = !model.isActive"
                        >{{ model.isActive ? 'Deactivate' : 'Reactivate' }}</a
                    >
                }
                <button #submit [hidden]="true"></button>
            </pcg-control-group>
        </div>
    </div>

    <div class="section-ctnr">
        <div class="section-head">
            <fa-icon [icon]="faIconName.faUser" class="mr-3"></fa-icon>
            <h1>User</h1>
        </div>
        <hr />

        <div class="row">
            <!-- Full Name field -->
            <pcg-control-group class="col-md-4" label="Full Name" [validations]="fullNameValidation">
                <input
                    pcgControlRef
                    class="form-control"
                    type="text"
                    formControlName="fullName"
                    (change)="fullNameChange()"
                />
            </pcg-control-group>

            @if (isPcg) {
                <div class="col-md-4">
                    <label class="for">Load Balance Test String</label>
                    <input pcgControlRef class="form-control" type="text" formControlName="loadBalanceTestString" />
                </div>
            }

            <!-- Username field -->
            @if (id === 0 || model.isNewUser) {
                <pcg-control-group class="col-md-4" label="Username" [validations]="userNameValidation">
                    <input pcgControlRef class="form-control" type="text" formControlName="userName" />
                </pcg-control-group>
            }
        </div>

        <div class="row">
            <!-- Phone field -->
            <pcg-control-group class="col-md-4" label="Phone" [validations]="phoneValidation">
                <input
                    pcgPhoneExt
                    pcgControlRef
                    class="form-control"
                    type="text"
                    inputmode="tel"
                    formControlName="phoneNumber"
                    maxlength="21"
                />
            </pcg-control-group>

            <!-- Email field -->
            <pcg-control-group class="col-md-4" label="Email">
                <input pcgControlRef class="form-control email" type="text" formControlName="email" />
            </pcg-control-group>

            <!-- Send Welcome Email button -->
            @if (canSeePasswordButtons) {
                <div class="col-md-2 btn-ctnr">
                    <input
                        type="button"
                        (click)="resetPassword(true, false)"
                        class="btn btn-save btn-sm welcome-btn"
                        ngbTooltip="Send user a welcome email with their username and the ability to choose a new password."
                        value="Send Welcome Email"
                        id="btnSendWelcomeMessage"
                    />
                </div>
            }
        </div>
    </div>

    <div class="section-ctnr">
        <div class="section-head">
            <fa-icon [icon]="faIconName.faBuildingColumns" class="mr-3"></fa-icon>
            <h1>Associated Organization</h1>
        </div>
        <hr />

        <div class="row">
            <!-- Organization dropdown -->
            @if (isSysAdmin) {
                <pcg-control-group class="col-md-4" label="Organization">
                    <pcg-select
                        #orgs
                        placeholder="Select an Organization"
                        [sendFormData]="false"
                        pcgControlRef
                        dataSource="api/Select/Organizations"
                        [queryParams]="{ showInactive: showInactive }"
                        formControlName="organizationId"
                        (change)="changeOrg()"
                    ></pcg-select>
                </pcg-control-group>
            } @else {
                <pcg-control-group class="col-md-4" label="Organization">
                    <span>{{ model?.organizationString }}</span>
                    <input type="hidden" formControlName="organizationId" />
                </pcg-control-group>
            }

            <!-- Permission dropdown -->
            @if (id === 0 || model.isNewUser) {
                <pcg-control-group class="col-md-3" label="Permission">
                    <pcg-select
                        placeholder="Select a Permission"
                        [sendFormData]="false"
                        pcgControlRef
                        dataSource="api/Select/Permissions"
                        formControlName="permissionId"
                    ></pcg-select>
                </pcg-control-group>

                <!-- Permissions Info button -->
                <div class="col-md-2 btn-ctnr">
                    <input
                        [class.permissionInfoCurrentUser]="isCurrentUser"
                        [class.permissionInfoNotCurrentUser]="!isCurrentUser"
                        type="button"
                        value="Permissions Info"
                        (click)="openPermissionsInfoModal()"
                        class="btn btn-save btn-sm"
                        tabindex="-1"
                    />
                </div>
            }
        </div>
    </div>

    <pcg-fixed-buttons>
        @if (isMobile && iAmMe) {
            <a class="btn btn-danger btn-lg" (click)="executeLogout()">
                <fa-icon [icon]="faIconName.faPowerOff"></fa-icon>
            </a>
        } @else if (!isMobile && iAmMe) {
            <a class="btn btn-lg logout-btn" (click)="executeLogout()">
                <fa-icon [icon]="faIconName.faPowerOff" class="unlock-icon"></fa-icon>
                Logout
            </a>
        }
        @if (!isCurrentUser || canManageUsers) {
            <a class="btn btn-cancel btn-lg" href="/users/list">Back to List</a>
        }
        @if (id !== 0) {
            <button class="btn btn-save btn-lg" [disabled]="!formGroup.valid">Save</button>
        } @else {
            <button class="btn btn-save btn-lg" [disabled]="!formGroup.valid">Next</button>
        }
    </pcg-fixed-buttons>
</form>
